import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Breadcrumb, { BreadcrumbItem } from 'view/section/Breadcrumb/Breadcrumb';
import { Conteudo } from 'view/section/Conteudo/Conteudo';
import { Botao } from 'view/component/Botao/Botao';
import MembroUnidadeTable from 'view/component/MembroUnidadeTable/MembroUnidadeTable';
import MembroUnidadeModal from 'view/component/MembroUnidadeModal/MembroUnidadeModal';
import { MensagensErroServidor } from 'view/component/MensagensErroServidor/MensagensErroServidor';
import { RootState } from 'store/store';
import { MembroUnidadeGetAllItemDTO } from 'model/reino/MembroUnidadeGetAllItemDTO';
import dayjs, { Dayjs } from 'dayjs';
import { MembroUnidadeDTO } from 'model/reino/MembroUnidadeDTO';


const UsuarioPermissaoPage: React.FunctionComponent = () => {

  const initialValues =  {
    id: null,
    idInstitucional: null,
    nome: '',
    papelMembro: null,
    idPapelMembro: null,
    dataInicio: dayjs(), 
    unidade: null,
    idUnidade: null
  }
//unidade, papelMembro, dataInicio, idInstitucional
  const [editMembroUnidade, setEditMembroUnidade] = useState<MembroUnidadeDTO | null>(initialValues);
  const [isEditing, setIsEditing] = useState(false);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const closeModal = () => setIsModalOpen(false);

  const erros = useSelector((state: RootState) => state.membroUnidade.error);

  
  const handleAdd = () => {
    setEditMembroUnidade(initialValues);
    setIsEditing(false);
    setIsModalOpen(true);
  }

  const handleEdit = (membroUnidade: MembroUnidadeDTO) => {
    setEditMembroUnidade(carregarMembroParaEdicao(membroUnidade));
    setIsEditing(true);
    setIsModalOpen(true);
    console.log("OnEdit: ", membroUnidade, editMembroUnidade);
  }

  function carregarMembroParaEdicao(membroUnidade: MembroUnidadeDTO): MembroUnidadeDTO {
    return {
      ...membroUnidade,
      idPapelMembro: membroUnidade.papelMembro ? membroUnidade.papelMembro.id : null,
      idUnidade: membroUnidade.unidade ? membroUnidade.unidade.id : null,
    };
  }
  


  return (
    <>
      <Breadcrumb>
        <BreadcrumbItem href="/">Início</BreadcrumbItem>
        <BreadcrumbItem href="/admin">Administração</BreadcrumbItem>
        <BreadcrumbItem>Usuários</BreadcrumbItem>
      </Breadcrumb>

      <Conteudo>
        <Botao onClick={handleAdd}>Adicionar</Botao>
        <MensagensErroServidor erro={erros} />
        <MembroUnidadeTable onEdit={handleEdit} />
        <MembroUnidadeModal isOpen={isModalOpen} onClose={closeModal} initialValues={editMembroUnidade} />
      </Conteudo>
    </>
  )
}

export default UsuarioPermissaoPage;
